import { useParams, useNavigate } from "react-router-dom";
import JobDescription from "../../../Components/JobDescription";
import { useGetJobBySlugQuery } from "../../../redux/api/CareersApi/careersApi";
import LoaderSpinner from "../../../Components/LoaderSpinner";
import SEO from "../../../Components/SEO";

const JobDetail = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const { data: job, isLoading, error } = useGetJobBySlugQuery(slug);

  if (isLoading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center bg-light"
        style={{ height: "40vh" }}
      >
        <LoaderSpinner />
      </div>
    );
  }

  if (error || !job) {
    return (
      <div className="container py-5 text-center">
        <h3>Job Not Found</h3>
        <p>
          The position you are looking for might have been closed or removed.
        </p>
        <button
          className="btn btn-primary"
          onClick={() => navigate("/careers")}
        >
          Back to Careers
        </button>
      </div>
    );
  }

  return (
    <>
      <SEO
        title={job.meta_title || `${job.title} - Career at Ideal`}
        description={job.meta_description}
        keywords={job.meta_keyword}
      />
      <JobDescription
        jobTitle={job.title}
        location={job.location}
        department={job.category}
        jobType={job.jobType}
        experienceLevel={job.experienceLevel}
        roleDescription={job.roleDescription}
        responsibilities={job.responsibilities}
        skills={job.skills}
        requirements={job.requirements}
        benefits={job.benefits}
        onApply={() => navigate(`/apply/${job.id}`)}
        applyUrl={`/apply/${job.id}`}
      />
    </>
  );
};

export default JobDetail;
